import styled from 'styled-components';

export const SuedPartiesContainer = styled.div`
  .sued_party_container {
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
    margin-left: 20px;
  }
  .vehicules_div {
    min-width: 100px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    margin-right: 16px;
    padding: 0 12px;
    text-align: center;
    font-size: 15px;
    color: #ffffff;
  }
`;
